import Vue from 'vue';
import Meta from 'vue-meta';
import createStore from './vuex';
import createRouter from './router';
import App from './App.vue';
import ColorParagraph from './pages/colorful-paragraph.vue';
import './style.css';
import { VToast as vToast } from '@bilibili/sakura';
import { webpImg } from '../public';
Vue.prototype.$toast = vToast({
    duration: 1500,
    timeout: 1500,
});
Vue.prototype.webpImg = webpImg;
Vue.use(Meta);
Vue.component('cp', ColorParagraph);
export function createApp() {
    const store = createStore();
    const router = createRouter();
    const app = new Vue({
        store,
        router,
        render: h => h(App),
    });
    return { app, router, store };
}
